import { diffWordsWithSpace, type Change } from "diff";

export type EditDiffSpan = {
  text: string;
  kind: "same" | "add" | "remove";
};

export function buildWordDiffSpans(before: string, after: string): EditDiffSpan[] {
  const changes: Change[] = diffWordsWithSpace(before || "", after || "");
  const spans: EditDiffSpan[] = [];
  for (const change of changes) {
    if (change.added) {
      spans.push({ text: change.value, kind: "add" });
    } else if (change.removed) {
      spans.push({ text: change.value, kind: "remove" });
    } else {
      spans.push({ text: change.value, kind: "same" });
    }
  }
  return spans;
}

export type FieldDiffRow = {
  field: string;
  before: string;
  after: string;
  spans: EditDiffSpan[];
};

export function buildFieldDiffRows(
  before: Record<string, unknown>,
  after: Record<string, unknown>,
): FieldDiffRow[] {
  const keys = Array.from(new Set([...Object.keys(before), ...Object.keys(after)])).sort();
  const rows: FieldDiffRow[] = [];
  for (const field of keys) {
    const beforeText = stringifyFieldValue(before[field]);
    const afterText = stringifyFieldValue(after[field]);
    if (beforeText === afterText) continue;
    rows.push({
      field,
      before: beforeText,
      after: afterText,
      spans: buildWordDiffSpans(beforeText, afterText),
    });
  }
  return rows;
}

function stringifyFieldValue(value: unknown): string {
  if (value == null) return "";
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean") return String(value);
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}
